<template>
  <div class="peer-reviews">
    <v-card flat class="mt-3">
      <v-card-title>
        <span class="headline text-h6">Peer Reviews </span>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <!--        <v-row>-->
        <!--          <v-col cols="12" md="4" offset="8">-->
        <!--            <v-select-->
        <!--              v-if="peerReviews.length > 0"-->
        <!--              v-model="selectedPeriod"-->
        <!--              prepend-inner-icon="filter_alt"-->
        <!--              color="primary"-->
        <!--              dense-->
        <!--              :items="periods"-->
        <!--              :item-text="(item) => item.code"-->
        <!--              :item-value="(item) => item.code"-->
        <!--              label="Filter by period"-->
        <!--              @change="filterAppraisalList"-->
        <!--            ></v-select>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
        <v-row no-gutters>
          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                <PeerReviewTable
                  :peerReviews="peerReviews"
                  :headers="headers"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RouterMixin from "@kinetics254/cassandra-base/mixins/RouterMixin";
import AppraisalMixin from "@/packages/cassandra-appraisal/modules/appraisalv3/AppraisalMixin";
import PeerReviewTable from "./PeerReviewTable.vue";

export default {
  name: "PeerReviews",
  mixins: [RouterMixin, AppraisalMixin],
  components: { PeerReviewTable },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("appraisal/getPeriods");
      v.$store.dispatch("appraisal/getKpi");
      v.$store.dispatch("appraisal/getRatingScale");
      v.$store.commit("appraisal/SET_REVIEW", false);
      v.$store.dispatch("appraisal/getPeerReviewers", {
        records: "peerReviewer",
      });
    });
  },
  data: () => ({
    selectedPeriod: "",
    period: "",
  }),
  computed: {
    headers() {
      return [
        {
          text: "Review Document",
          sortable: true,
          value: "reviewID",
        },
        {
          text: "PerName Name",
          sortable: true,
          value: "peerName",
        },
        { text: "Actions", value: "action" },
      ];
    },
    peerReviews() {
      return (
        this.$store.getters["appraisal/appraisalGetter"]("peerReviewers") || []
      );
    },
    periods() {
      return this.$store.getters["appraisal/appraisalGetter"]("periods") || [];
    },
  },
  mounted() {
    Event.$on("peerCommentAdded", () => {
      this.$store.dispatch("appraisal/getPeerReviewers", {
        records: "peerReviewer",
      });
    });
  },
  methods: {
    filterAppraisalList() {
      this.period = this.selectedPeriod;
    },
  },
};
</script>
